/**
 * @generated SignedSource<<913cf6f186339ae07318e955a81ed046>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ProductSkuOfferDeliveryChannel = "DELIVERY" | "PICKUP_IN_POINT" | "TAKE_AWAY";
import { FragmentRefs } from "relay-runtime";
export type CollectionsShelfItem_IntelligentSearchProductResult$data = {
  readonly defaultImage: {
    readonly url: string;
  };
  readonly product: {
    readonly _id: string;
    readonly id: string;
    readonly name: string;
    readonly skus: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly images: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly url: string;
              };
            }>;
          };
        };
      }>;
    };
    readonly " $fragmentSpreads": FragmentRefs<"ProductSkuRef_Product">;
  };
  readonly offers: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly sku: {
          readonly _id: string;
          readonly id: string;
          readonly refId: string | null;
          readonly defaultImage: {
            readonly url: string;
          };
        };
        readonly seller: {
          readonly _id: string;
        };
        readonly deliveryChannel: ProductSkuOfferDeliveryChannel;
        readonly listPrice: {
          readonly amount: number;
        };
        readonly netPrice: {
          readonly amount: number;
        };
        readonly priority: number;
      };
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"ProductSkuAvailabilityDelivery_ProductSkuOfferConnection" | "ProductSkuAvailabilityPickup_ProductSkuOfferConnection" | "ProductSkuAvailabilityTakeAway_ProductSkuOfferConnection">;
  } | null;
  readonly promotions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly highlight: boolean | null;
      };
    }>;
  } | null;
  readonly " $fragmentType": "CollectionsShelfItem_IntelligentSearchProductResult";
};
export type CollectionsShelfItem_IntelligentSearchProductResult$key = {
  readonly " $data"?: CollectionsShelfItem_IntelligentSearchProductResult$data;
  readonly " $fragmentSpreads": FragmentRefs<"CollectionsShelfItem_IntelligentSearchProductResult">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": 420
    }
  ],
  "kind": "ScalarField",
  "name": "url",
  "storageKey": "url(size:420)"
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductSkuImage",
  "kind": "LinkedField",
  "name": "defaultImage",
  "plural": false,
  "selections": [
    (v0/*: any*/)
  ],
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = [
  {
    "kind": "Variable",
    "name": "addresses",
    "variableName": "addresses"
  }
],
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "addresses"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CollectionsShelfItem_IntelligentSearchProductResult",
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "product",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductSkuConnection",
          "kind": "LinkedField",
          "name": "skus",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductSkuEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProductSku",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v3/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProductSkuImageConnection",
                      "kind": "LinkedField",
                      "name": "images",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ProductSkuImageEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "ProductSkuImage",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v3/*: any*/),
                                (v0/*: any*/)
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProductSkuRef_Product"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v5/*: any*/),
      "concreteType": "ProductSkuOfferConnection",
      "kind": "LinkedField",
      "name": "offers",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductSkuOfferEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductSkuOffer",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProductSku",
                  "kind": "LinkedField",
                  "name": "sku",
                  "plural": false,
                  "selections": [
                    (v2/*: any*/),
                    (v3/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "refId",
                      "storageKey": null
                    },
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Seller",
                  "kind": "LinkedField",
                  "name": "seller",
                  "plural": false,
                  "selections": [
                    (v2/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "deliveryChannel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Money",
                  "kind": "LinkedField",
                  "name": "listPrice",
                  "plural": false,
                  "selections": (v6/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Money",
                  "kind": "LinkedField",
                  "name": "netPrice",
                  "plural": false,
                  "selections": (v6/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "priority",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProductSkuAvailabilityDelivery_ProductSkuOfferConnection"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProductSkuAvailabilityPickup_ProductSkuOfferConnection"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProductSkuAvailabilityTakeAway_ProductSkuOfferConnection"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v5/*: any*/),
      "concreteType": "PromotionConnection",
      "kind": "LinkedField",
      "name": "promotions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PromotionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Promotion",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                (v4/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "highlight",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "IntelligentSearchProductResult",
  "abstractKey": null
};
})();

(node as any).hash = "630d258aa20d43819ce93d78b6b615a2";

export default node;
